<template>
  <section>
    <b-row class="mt-2">
      <b-col class="my-access-title mb-2" lg="6" md="12" sm="12" xl="6">Manage Your Access</b-col>
      <!-- <b-col class="my-access-explain" lg="6" md="12" sm="12" xl="6"
        >Use this page as a single point to manage all personal access to the external systems. Any
        change to your access will need to undergo evaluation and usually takes 1 to 3 days to be
        fully processed.
      </b-col> -->
    </b-row>
    <hr class="solid py-1" />
  </section>
</template>

<script>
  export default {
    name: 'my-access-header',
  };
</script>

<style scoped>
  .my-access-title {
    font-weight: 600;
    font-size: 26px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #383838;
  }

  .my-access-explain {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #006a68;
  }
</style>
